export module STATIC_VALUE {

    export const HTTP_HEADER = {
        AUTH: 'Authorization',
        CHANNEL: 'X-Channel-ID',
        VALIDATION: 'X-Validation-ID',
        CONTENT_TYPE: 'Content-Type'
    };

    export const TABLE = {
        PAGE_SIZE: 10
    }

    //Kowsalya
    /*  export const FAQ_LIST = [
          {
              question: "How to register as new user??",
              answer: "Click on �Sign Up� menu."
          },
          {
              question: "Earthwork Details?",
              answer: "Login and go to �Purchase Plant Map� menu."
          },
          { 
              question: "Declaration",
              answer: "Login and go to �NCE� menu"
          }
      ];*/
    //Kowsalya

    export const SECURITY_QUESTION_LIST = [
        {
            question: "What is your favourite book?"
        },
        {
            question: "What is the name of the road you grew up on?"
        },
        {
            question: "What is your mother's maiden name?"
        },
        {
            question: "What was the name of your first/current/favourite pet?"
        },
        {
            question: "What was the first company that you worked for?"
        },
        {
            question: "Where did you meet your spouse?"
        },
        {
            question: "Where did you go to high school/college?"
        },
        {
            question: "What is your favourite food?"
        },
        {
            question: "What city were you born in?"
        },
        {
            question: "Where is your favourite place to vacation?"
        }
    ]

    export const DESIGNATION_LIST = [
        {
            value: "Mr."
        },
        {
            value: "Ms."
        },
        {
            value: "Mrs."
        }
    ]

    export const ALL_PLANT_STATUS = {
        PAYMENT_IN_PROGRESS: 'PM_00',
        PAYMENT_RECEIVED: 'PM_01',
        PRINTING_FAILED: 'PM_02',
        PAYMENT_FAILED: 'PM_03',
        PENDING_MAP_COLLECTION: 'PM_04',
        PAYMENT_PENDING: 'PM_05',
        PAYMENT_CANCELLED: 'PM_06',
        PAYMENT_CANCELLED_BY_MERCHANT: 'PM_07',
        RA_PAYMENT_RECEIVED: 'PM_95',
        MAP_DELIVERED: 'PM_96',
        REQUEST_REJECTED: 'PM_97',
        PAYMENT_NA: 'PM_98',
        DONE: 'PM_99',


    }

    export const ALL_NCE_STATUS = {
        PAYMENT_IN_PROGRESS: 'NCE_00',
        PAYMENT_FAILED: 'NCE_03',
        PAYMENT_PENDING: 'NCE_07',
        PENDING_BRIEFING_SCHEDULE: 'NCE_08',
        PENDING_PROVISIONING: 'NCE_02',
        PENDING_APPOINTMENT_SCHEDULE: 'NCE_09',
        PENDING_TRIAL_HOLE_INSPECTION: 'NCE_04',
        REJECTED: 'NCE_05',
        WAIT_DIVERSION: 'NCE_06',
        APPROVED: 'NCE_99',
        PENDING_BRIEFING_DOCUMENT: 'NCE_10',
        PENDING_APPOINTMENT_DOCUMENT: 'NCE_11',
        APPOINTMENT_DOCUMENT_UPLOAD: 'NCE_12',
        CANCELLED: 'NCE_13',
        EXPIRED: 'NCE_14',
        REJECTED_BRIEFING_DOCUMENT: 'NCE_15',
        REJECTED_APPOINTMENT_DOCUMENT: 'NCE_16',
        APPLICATION_EXPIRED: 'NCE_18',
        APPLY_FINAL_APPROVAL: 'NCE_19',
        INSPECTION_FINAL_APPROVAL: 'NCE_20',
        APPLY_FINAL_APPROVAL_REJECTED: 'NCE_21',
        PENDING_FINAL: 'NCE_23'
    }

    export const NCE_EARTHWORK_REMARKS = [
        "Open Trench Excavation",
        "Sinking of earth rod, casing, or tubes",
        "Soil Investigation",
        "Boring, dredging, jacking, leveling, pilling, or tunneling"
    ]

    export const NCE_CONTRACT_PRINCIPALS = [
        "LTA",
        "PUB",
        "HDB",
        "Other Agencies & Pte"
    ]

    //GANESH
    export const SEARCH_BY = {
        customer: [
            {
                type: "requestId",
                plantValue: "PRP Ref. No.",
                nceValue: "NCE Ref No",
            },
            {
                type: "location",
                plantValue: "Location",
                nceValue: "Location",
            },
            {
                type: "applicationDate",
                plantValue: "Purchase Date",
                nceValue: "Request Date",
            },
            {
                type: "appointmentDate",
                plantValue: "",
                nceValue: "Appointment Date",
            }
        ],
        admin: [
            {
                type: "requestId",
                plantValue: "PRP Ref. No.",
                nceValue: "NCE Ref No",
            },
            {
                type: "location",
                plantValue: "Location",
                nceValue: "Location",
            },
            {
                type: "applicationDate",
                plantValue: "Purchase Date",
                nceValue: "Request Date",
            }
            // {
            //     type: "companyName",
            //     plantValue: "Company Name",
            //     nceValue: "Company Name",
            // },
            // {
            //     type: "appointmentDate",
            //     plantValue: "",
            //     nceValue: "Appointment Date",
            // }
        ],
        adminUserAccount: [
            {
                type: "companyName",
                plantValue: "Company Name",
                nceValue: "Company Name",
            },
            {
                type: "email",
                plantValue: "Email",
                nceValue: "Email",
            },
        ]
    }
    export const PAYMENT_METHOD = {
        creditCard: {
            key: "CREDIT_CARD",
            value: "Credit/Debit Card"
        },
        enets: {
            key: "ENETS_IB",
            value: "e-Nets"
        },
        dash: {
            key: "MCASH",
            value: "Dash"
        }
    }

    //Kowsalya
    export const PRP_REQUEST_VALIDATION_MSG = [
        "We noticed you have purchased the Plant Route Plan for the same location in the last 30 minutes. Are you sure you like to purchase the plan map of the same location again? "
    ]

    export const PRP_REQUEST_VALIDATION_LOGIN = [
        "We noticed that the Plant Route Plan purchase exceeded daily limit. Please purchase Plant Route Plan by tomorrow."
    ]

    export const TERMS_AND_CONDITIONS_LOGIN = [
        `A person not a party to this agreement shall have no right under the Singapore Contracts (Rights of Third Parties) Act (Cap. 53B) to enforce any of the terms of this agreement.
        NetLink Management Pte. Ltd. has assumed all obligations under this agreement in its capacity as trustee of NetLink Trust and not in its personal capacity and any liability of NetLink Management Pte. Ltd. (as trustee of NetLink Trust) under this agreement is limited to the assets of NetLink Trust over which NetLink Management Pte. Ltd. has recourse and shall not extend to any personal or other assets of NetLink Management Pte. Ltd. or its shareholders, directors, officers or employees.`
    ]
    export const TERMS_AND_CONDITIONS_PURCHASE = [
        `Each Purchase Order placed by buyer for goods and/or services is subject to these standard purchase terms and the terms of the applicable Purchase Order, and is conditional upon Supplier�s agreement to such terms. Supplier shall be deemed to have agreed to be bound by such terms by accepting the Purchase Order, delivering the goods, and/or performing the services.`
    ]
    export const FAQ_LIST = [
        /*Commented by Anjaiah
         {
             question: "What are the required information when requesting for Plan Sale?",
             answer: "The contractor needs to fill up the request from for Netlink Trust's Plant Route Plans. Please also state the location on a clear location map and highlight the affected area."
         },
         {
             question: "How would I know if the Plan is ready for Download?",
             answer: "Upon successfull payment, plant map will be ready by 2 hours and available for download from My Orders"
         },
         { 
             question: "What is the associated cost for the Plan Route Plans?",
             answer: "The Plant route Plan is chargeable at $43.60(inclusive of GST) per copy. The number of copies required would depend on the affected area. A large affected area may require more than one copy."
         }*/
        //Added by Anjaiah
        {
            question: "What is PRP?",
            answer: "PRP stands for Plant Route Plan.",
            answer1: "The Plan indicates the approximate route of NetLink Trust's underground ducts and/or cables.",
            expandStatus: true
        },
        {
            question: "Who should submit the PRP purchase?",
            answer: "PRP must be purchased by earthwork contractors, consultants and developers who will be carrying out the actual earthworks at the development sites; so that they are aware of the approximate duct and/or cable locations. The exact locations of the duct and/or cables are to be confirmed by digging trial holes manually.",
            expandStatus: true
        },
        {
            question: "Is there a daily purchase limit on PRP purchase?",
            answer: "Yes. You can purchase a maximum of 10 PRP per day.",
            expandStatus: true
        },
        {
            question: "Is there a maximum selection area for PRP purchase?",
            answer: "Yes. For each PRP purchase, the maximum area that you can select will be 1 Square Kilometre any area within Singapore.",
            expandStatus: true
        },
        {
            question: "Is there a possibility that certain area does not contain NetLink Trust’s underground ducts and/or cables?",
            answer: "Yes. We do not cover 100% of the network coverage in Singapore.",
            expandStatus: true
        },
        {
            question: "What is the procedure to purchase PRP on restricted area?",
            answer: "For restricted area, you be prompt to upload the authorization letter for our verification. Once the verification process completed, you will be notified via email on the status of the purchase.",
            answer1: "For approved purchase, you are required to complete your payment. The purchase will be void if no successful payment is received within 24 hours. You may locate the purchase under ‘My Order’ page to complete your payment.",
            expandStatus: true
        },
        {
            question: "When will I receive the PRP purchase after payment is completed?",
            answer: "For non-restricted area, the digital Plant Map will be available for download via 'My Orders' page in 2 Hours. You may access 'My Orders' page from the Welcome page.",
            answer1: "For restricted area, we will contact you via your email to collect the hard copy Plant Map from our office.",
            expandStatus: true
        },
        {
            question: "What can I do if I have yet to receive the PRP after 2 hrs? ",
            answer: "If the digital Plant Map is not available for download via 'My Orders' page after 2 Hours, please drop us an email #EMAIL# with the PRP Ref. No. and we will do our best to get in touch within 3 business day.",
            expandStatus: true
        },
        {
            question: "Is there a validity period for PRP?",
            answer: "Yes. Each PRP is valid for a period of 6 months from the purchase date.",
            expandStatus: true
        },
        {
            question: "How can I see my purchase history?",
            answer: "You can view your purchase history and its expiry date via 'My Orders' page. You may access 'My Orders' page from the Welcome page.",
            expandStatus: true
        },
        {
            question: "What are the associated charges for PRP purchase?",
            answer: "The plant route plan is chargeable at $43.60 per page inclusive GST. The number of pages required would depend on the selected plan location.",
            expandStatus: true
        },
        {
            question: "What are the available payment modes?",
            answer: "We accept payment by Credit and Debit card (Visa or Mastercard).",
            expandStatus: true
        },
        {
            question: "Can I cancel the PRP purchase after payment is completed?",
            answer: "No. Cancellation of the PRP purchase is not allowed and payment is non-refundable. Do ensure that the PRP purchase is required and correct before proceeding with payment.",
            expandStatus: true
        },
        {
            question: "How would I know that my payment is successful?",
            answer: "If your payment is successful, you will see the successful message and you may locate the purchase under ‘My Order’ page.",
            answer1: "If your payment is unsuccessful, you will see the unsuccessful message. You may locate the purchase under ‘My Order’ page to make your payments again within 24 hours. The purchase will be void if no successful payment is received within 24 hours.",
            answer2: "You may access 'My Orders' page from the Welcome page.",
            expandStatus: true
        },
        {
            question: "Will I receive a payment e-invoice after my payment is successful? ",
            answer: "Yes. The payment e-invoice will be available for download via 'My Orders' immediately after your PRP purchase is successfully completed. You may access 'My Orders' page from the Welcome page.",
            expandStatus: true
        },
        {
            question: "Can I request to have the payment e-invoice bill to a different billing party?",
            answer: "No. The payment e-invoice generated based on your registered profile.",
            expandStatus: true
        },
        {
            question: "How do I sign up for an PRP account?",
            answer: "You may sign up for a PRP account by clicking the “Sign Up” button at the portal home page. An email with the verification code will be sent to you to complete your account verification.",
            expandStatus: true
        },
        {
            question: "Can I sign up for an PRP account without completing the account verification?",
            answer: "No. Your PRP account will not be setup if you do not complete the account verification. The account verification step is required to ensure that you have registered a valid email address with us.",
            expandStatus: true
        },
        {
            question: "Is there a validity period for the verification code?",
            answer: "Yes. The verification code will be expired after 1 day.",
            expandStatus: true
        },
        {
            question: "The verification code has expired. What should I do?",
            answer: "You have to login with the credentials that you provided during sign up and it will take you to the account verification page. Please click the re-send verification code button and an email with the verification code will be sent to you to complete your account verification.",
            expandStatus: true
        },
        {
            question: "What can I do if I don’t receive the verification code email?",
            answer: "If you are not receiving the verification code email, it is possible the email is going in your spam mailbox. It may also be possible that you have mistyped your email address when you did your sign up. If you mistyped your email address when signing up for your account, we are unable to give you the access to this account. You will need to sign up again with the correct email address.",
            expandStatus: true
        },
        {
            question: "How do I change my password?",
            answer: "After you have login into the portal, click on the 'My Profile’ page from the Welcome page. Then click on 'Change Password', key in the new password and click on the ‘Proceed' button to complete the password change.",
            expandStatus: true
        },
        {
            question: "How do I update my profile detail?",
            answer: "After you have login into the portal, click on the 'My Profile’ page from the Welcome page. You may update the necessary details under ‘My Profile’ section and click on the 'Update Profile' button to complete the update.",
            expandStatus: true
        },
        {
            question: "I have forgotten my password, how do I reset it?",
            answer: "Password can be reset by clicking 'Forgot Password' link via the Portal Home page. Simply key in your registered email address and security question’s answer, then click on the ‘Proceed’ button. An email with the verification code will be sent to you. You can complete the password reset by entering the verification code and your new password, click on the ‘Proceed’ button.",
            expandStatus: true
        },
        {
            question: "I need help with my account or purchase. Who can I contact?",
            answer: "Please drop us an email at #EMAIL#  and we will do our best to get in touch with you within 3 business days.",
            expandStatus: true
        },
    ];

    export const CONTACTUS = [
        {
            Mail: "prpnce-admin@netlinknbn.com"
        },
    ]

    export const PLANMAP_PURPOSE = {

        Planning: "1",
        Earthwork: "2",
        Others: "3"

    }

    export const DISTANCE = {
        distanceKm: 1.0
        //distanceKm : 1.25
    }

    export const DISTANCE_MSG = [
        "The selected location exceeds the maximum 1 square kilometer range. Please reduce the selection range. Thank You."
    ]

    export const OUT_OF_SINGAPORE = [
        "The selected location is not within Singapore. Please clear your selection and try again. Thank You."
    ]

    export const MAP_BOUNDARY = {
        latMin: 1.215271,
        latMax: 1.485734,
        lngMin: 103.603820,
        lngMax: 104.096832
    }
    export const MAP_BOUNDARY1 = {
        latMin: 1.159665,
        latMax: 1.253943,
        lngMin: 103.601074,
        lngMax: 104.116516
    }
    //Kowsalya
}


// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/shared/configuration/static.value.ts